<template>
	<div>
		<div
			id="panel_advices"
			class="panel advices"
			:class="[
				isHeaderIndent? 'mt-0 pt-1' : '',
				isFooterIndent? 'mb-0 pb-1' : '',
				block.appearance,
			]"
		>
			<div>
				<div class="container">
					<div
						v-if="isHeaderVisible"
						:class="[
							'panel_header',
							isBrand? 'sk' : '',
						]"
					>
						<div class="row align-items-end">
							<div class="col-12 col-lg-12">
								<h2 v-if="block.block_title === null">
									Рекомендуем
								</h2>
								<h2 v-else>
									{{ block.block_title }}
								</h2>
								<slides-menu-block
									v-if="hasTabs"
									v-model="tab"
									:items="tabs"
									disable-all
								/>
							</div>
						</div>
						<div
							class="advices_block new"
						>
							<div>
								<ul class="program_list new">
									<li
										v-for="(item, index) in items"
										:key="index"
										class="row d-flex align-self-center justify-content-start mb-0 advice-item"
									>
										<div class="d-none">
											{{ item.id }}
										</div>
										<!-- внешняя статья -->
										<div
											v-if="!item.is_has_blocks && item.project_content_download_link"
											class="col-12 col-sm-12 col-lg-12"
										>
											<div class="row schedule_data mb-0 py-4">
												<div v-if="!block.is_hide_images" class="col-12 col-md-4 col-lg-3">
													<a
														:href="item.project_content_download_link"
														target="_blank"
													>
														<b-img-lazy
															v-if="item.listing_cover_small_blocks_url"
															class="w-100 mb-4 mb-md-0"
															:src="item.listing_cover_small_blocks_url"
															:alt="item.title"
															blank-color="lightgray"
															center
															block
														/>
													</a>
												</div>
												<div v-if="block.is_hide_images" class="col-12">
													<div
														v-if="item.date"
														class="date text-muted"
														:class="[
															'block_title_icon',
															'block_title_icon-' + item.type
														]"
													>
														{{ item.date | moment('DD MMMM YYYY') }}
													</div>
													<a
														:href="item.project_content_download_link"
														class="title"
														target="_blank"
													>
														<span class="mb-2 d-inline-block">{{ item.title }}</span>
													</a>
													<p v-if="item.intro" class="description mb-2">
														{{ item.intro }}
													</p>
													<div v-if="item.people" class="mt-4">
														{{ item.people.map((p) => p.title).join(', ') }}
													</div>
												</div>
												<div v-else class="col-12 col-md-8 col-lg-9">
													<div
														v-if="item.date"
														class="date text-muted"
														:class="[
															'block_title_icon',
															'block_title_icon-' + item.type
														]"
													>
														{{ item.date | moment('DD MMMM YYYY') }}
													</div>
													<a
														:href="item.project_content_download_link"
														class="title"
													>
														<span class="mb-2 d-inline-block">{{ item.title }}</span>
													</a>
													<p v-if="item.intro" class="description mb-2">
														{{ item.intro }}
													</p>
													<div v-if="item.people" class="mt-4">
														{{ item.people.map((p) => p.title).join(', ') }}
													</div>
													<a
														:href="item.project_content_download_link"
														class="btn btn-primary"
													>
														{{ $t('more') }}
													</a>
												</div>
											</div>
										</div>
										<!-- внутренняя статья -->
										<div
											v-if="item.is_has_blocks && !item.project_content_download_link"
											class="col-12 col-sm-12 col-lg-12"
										>
											<div class="row schedule_data mb-0 py-4">
												<div v-if="!block.is_hide_images" class="col-12 col-md-4 col-lg-3">
													<nuxt-link
														:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
													>
														<b-img-lazy
															v-if="item.listing_cover_small_blocks_url"
															class="w-100 mb-4 mb-md-0"
															:src="item.listing_cover_small_blocks_url"
															:alt="item.title"
															blank-color="lightgray"
															center
															block
														/>
													</nuxt-link>
												</div>
												<div v-if="block.is_hide_images" class="col-12">
													<div
														v-if="item.date"
														class="date text-muted"
														:class="[
															'block_title_icon',
															'block_title_icon-' + item.type
														]"
													>
														{{ item.date | moment('DD MMMM YYYY') }}
													</div>
													<nuxt-link
														:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
														class="title"
													>
														<span class="mb-2 d-inline-block">{{ item.title }}</span>
													</nuxt-link>
													<p v-if="item.intro" class="description mb-2">
														{{ item.intro }}
													</p>
													<div v-if="item.people" class="mt-4">
														{{ item.people.map((p) => p.title).join(', ') }}
													</div>
													<nuxt-link
														:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
														class="btn btn-primary"
													>
														{{ $t('more') }}
													</nuxt-link>
												</div>
												<div v-else class="col-12 col-md-8 col-lg-9">
													<div
														v-if="item.date"
														class="date text-muted"
														:class="[
															'block_title_icon',
															'block_title_icon-' + item.type
														]"
													>
														{{ item.date | moment('DD MMMM YYYY') }}
													</div>
													<nuxt-link
														:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
														class="title"
													>
														<span class="mb-2 d-inline-block">{{ item.title }}</span>
													</nuxt-link>
													<p v-if="item.intro" class="description mb-2">
														{{ item.intro }}
													</p>
													<div v-if="item.people" class="mt-4">
														{{ item.people.map((p) => p.title).join(', ') }}
													</div>
													<nuxt-link
														:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
														class="btn btn-primary"
													>
														{{ $t('more') }}
													</nuxt-link>
												</div>
											</div>
										</div>
									</li>
								</ul>
								<b-pagination
									v-model="currentPage"
									:total-rows="total"
									:per-page="perPage"
									align="center"
									pills
									aria-controls="itemList"
									next-class="active"
									prev-class="active"
									prev-text="<"
									last-text=">>"
									next-text=">"
									first-text="<<"
								/>
							</div>
						</div>
						<div v-if="isFooterVisible && block.button.button_title" class="panel_footer">
							<div class="row">
								<div class="col-12">
									<dynamic-button
										:block-id="block.id"
										:button="block.button"
										:scenario="block.button.scenario"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';
import '@/utils/moment';
import SlidesMenuBlock from '~/components/refactor/SlidesMenuBlock.vue';
import { mapActions } from 'vuex';

export default {
	name: 'PanelDynamicMediasPagination',
	components: { SlidesMenuBlock },
	mixins: [panel],
	props: {
		block: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			tab: 0,
			currentPage: 1,
			perPage: null,
			total: null,
			items: [],
		};
	},
	computed: {
		hasTabs() {
			return Array.isArray(this.block.items) && this.block.items.length > 0;
		},
		tabs() {
			if (!this.hasTabs) return null;

			const t = {};
			// eslint-disable-next-line camelcase
			this.block.items.forEach(({ title }, index) => {
				// eslint-disable-next-line camelcase
				t[index] = title;
			});
			return t;
		},
		url() {
			return this.block.items[this.tab].url;
		},
	},
	watch: {
		currentPage() {
			this.getContent();
		},
		tab() {
			this.currentPage = 1;
			this.getContent();
		},
	},
	mounted() {
		this.getContent();
	},
	// created() {
	// 	// this.checkValue();
	// 	if (this.$store.state.alumni.panelMediaPagination && !this.$auth.loggedIn) {
	// 		this.showLoginPopup();
	// 	}
	// },
	methods: {
		async getContent() {
			this.$axios.get(`${this.url}?page=${this.currentPage}`)
				.then((response) => {
					if (response.data) {
						this.fillContent(response.data);
					}
				})
				.catch((e) => {
					console.log(e.message);
				});
		},
		fillContent(data) {
			this.items = data.data;
			this.perPage = data.per_page;
			this.total = data.total;
		},
		...mapActions({
			showLoginPopup: 'authModal/showLogin',
		}),
		// ...mapMutations({
		// 	checkAlumni: 'alumni/panelMediaPagination',
		// }),
		// checkValue() {
		// 	if (this.block.is_alumni === true) {
		// 		this.checkAlumni(true);
		// 	}
		// },
	},
};
</script>

<style lang="scss" scoped>
@import "/assets/styles/components/blocks/issue-graduate-tips";
@import "/assets/styles/components/home/panel-explist";
@import "/assets/styles/components/home/panel-schedule";

.page-link {
		color: $body-color !important;
		background-color: $white !important;
		border-color: $primary !important;
	&:hover {
		 border-color: $primary !important;
		 background-color: lighten($primary, 5%) !important;
		 color: $white !important;
	}
}
.active {
	.page-link {
			color: $white !important;
			background-color: $primary !important;
			border-color: $primary !important;
		&:hover {
			 border-color: $primary !important;
			 background-color: lighten($primary, 5%) !important;
			 color: $white !important;
		}
	}
}

.panel_header {
	margin-bottom: 0 !important;
}

.programm_schedule {
	// margin-top: 3rem;
	.panel_footer {
		margin-top: 1.5rem;
	}

	.title {
		margin-bottom: 1rem;
	}

	.schedule_list {
		border-bottom: 1px solid $body-color; // margin-bottom: 3rem;
	}

	.schedule_time {
		margin-bottom: 1rem;
		height: auto;
	}
}

.pagination {
	padding-top: 20px;
}
.program_list {
	margin: 0rem 0 -2.5rem 0;
	padding: 1.5rem 0 0 0;
}
</style>
